import { MortgageMasterView } from 'features/mortgage';

const MortgagePage = () => <MortgageMasterView />;

export default MortgagePage;
